import React from 'react';
import styled from 'styled-components';
import { SvgComponent } from '../../assets';
import { theme } from '../../theme';
import { UIText } from '../typography';

export type ToggleButtonProps = {
  detail?: string;
  icon?: SvgComponent;
  onClick: (value: string) => void;
  selected?: boolean;
  value: string;
  tabIndex?: number;
};

type LabelProps = {
  hasIcon: boolean;
  selected: boolean;
};

const Label = styled.label<LabelProps>`
  background-color: ${theme.colors.primary.white};
  border-radius: ${theme.borderRadius.default};
  border: 1px solid ${theme.colors.neutrals.solidGrays[5]};
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: ${({ hasIcon }) => (hasIcon ? '165' : '105')}px;
  padding: ${theme.spacings[4].rem};
  transition: background-color 200ms ease-in, border-color 200ms ease-in;

  &:hover {
    border-color: ${theme.colors.primary.graysBlue};
  }

  ${({ selected }) =>
    selected &&
    `
    background-color: ${theme.colors.tints.systemBlue[7]};
    border-color: ${theme.colors.primary.graysBlue};
    `}
`;

const IconContainer = styled.div`
  text-align: center;

  svg {
    fill: ${theme.colors.primary.graysBlue};
    margin-bottom: ${theme.spacings[3].rem};
  }
`;

const Text = styled(UIText)`
  font-weight: 700;
  text-align: center;
`;

const Detail = styled.span`
  display: block;
`;

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  icon: Icon,
  value,
  detail,
  onClick,
  selected = false,
  tabIndex,
  ...props
}) => (
  <Label
    hasIcon={!!Icon}
    key={value}
    onClick={() => onClick(value)}
    selected={selected}
    tabIndex={tabIndex}
    {...props}
  >
    {Icon && (
      <IconContainer>
        <Icon />
      </IconContainer>
    )}
    <Text>
      {value}
      {detail && <Detail>{detail}</Detail>}
    </Text>
  </Label>
);
